
import React from 'react';
import { ArrowRight } from 'lucide-react';

interface CTASectionProps {
  title: string;
  description: string;
  primaryButtonText: string;
  whatsappMessage: string;
}

const CTASection = ({ title, description, primaryButtonText, whatsappMessage }: CTASectionProps) => {
  return (
    <section className="py-20 bg-navy-50/50">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-light text-navy-900 mb-6">
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </h2>
          <p className="text-xl text-navy-600 mb-8 font-light">
            {description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="mailto:julycia.pro@gmail.com"
              className="bg-blue-600 text-white px-8 py-4 font-medium hover:bg-blue-700 transition-colors duration-300 group inline-flex items-center justify-center gap-2"
            >
              {primaryButtonText}
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
            </a>
            <button 
              onClick={() => {
                const phoneNumber = "+33643581540";
                const whatsappUrl = `https://wa.me/${phoneNumber.replace(/\D/g, '')}?text=${encodeURIComponent(whatsappMessage)}`;
                window.open(whatsappUrl, '_blank');
              }}
              className="bg-green-500 text-white px-8 py-4 font-medium hover:bg-green-600 transition-colors duration-300 group inline-flex items-center justify-center gap-2"
            >
              Discuter sur WhatsApp
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
